export default {
  coffeeData: {
    windBreaker: "Albero di rottura del vento",
    horticultureInfo: "Albero di orticoltura",
    shadeTree: "Albero di ombre",
    coffeeVariety: "Varietà di caffè",
    coffeeSpecies: "Specie di caffè",
    coffeeCherryQuality: "Qualità della Ciliegia di Caffè",
    processingBatchQuality: "Qualità del Lotto di Lavorazione",
    greenCoffeeQuality: "Qualità del Caffè Verde",
    processType: "Tipo di Processo",
    updateWindBreaker: "Aggiorna il vento Tipo di albero di rottura",
    addWindBreaker: "Aggiungi nuovo ventoBreaker Tipo albero",
    updateHorticultureInfo:
      "Aggiornamento orticoltura Informazioni Tipo albero",
    addHorticultureInfo: "Aggiungi nuova orticoltura Informazioni Tipo albero",
    updateShadeTree: "Aggiorna il tipo di albero da ombra",
    addShadeTree: "Aggiungi nuovo tipo di albero da ombra",
    updateCoffeeVariety: "Aggiornare il caffè Tipo di albero variegato",
    addCoffeeVariety: "Aggiungi nuovo caffèVariety Albero Tipo",
    deleteVarietyTitle: "Eliminare la varietà",
    deleteVarietyMessage: "Sei sicuro di voler eliminare Variety?",
    updateCoffeeSpecie: "Aggiornamento Caffè Specie",
    deleteSpecieTitle: "Eliminare la specie",
    deleteSpecieMessage: "Sei sicuro di voler eliminare Specie?",
    addCoffeeSpecie: "Aggiungere Nuova varietà di caffè",
    variety: "Varietà",
    selectVariety: "Selezionare Specie",
    selectSpecie: "Selezionare Specie",
    deleteCoffeeRecord: "Sei sicuro di voler eliminare il record?",
    deleteCoffeeData: "Eliminare i dati del caffè",
    topicRequired: "Seleziona argomento è necessario",
    coffeeAddSuccess: "Caffè Specie aggiunto con successo.",
    treeTypeSuccess: "Tipo di albero aggiunto con successo.",
    treeTypeUpdateSuccess: "Tipo di albero aggiornato con successo.",
    coffeeVarietySuccess: "Varietà di caffè aggiunto con successo.",
    coffeeSpecieSuccess: "Caffè specie aggiornato con successo.",
    nameRequired: "Il nome è richiesto",
    notFound: "No Admin Dati del caffè Trovato",
  },
  cacaoData: {
    cacao: "Cacao",
    cacaoVariety: "Varietà di Cacao",
    cacaoSpecies: "Cacao Specie",
    cacaoWeight: "Cacao Peso",
    cacaoOverview: "Cacao Panoramica",
    cacaoType: "Cacao Tipo",
    deleteCacaoData: "Eliminare i dati di Cacao",
    productWeight: "Peso del prodotto",
    productType: "Tipo di prodotto",
    productPricePerKg: "Prezzo per KG",
    registerFermentation: "Fermentazione del registro",
    batchVisualIdentification: "Indentificazione visiva batch",
    initialWeight: "Peso iniziale",
    finalWeight: "Peso finale",
    performance: "Prestazioni",
    fermentationPercentage: "Percentuale di fermentazione",
    fermetationMethod: "Metodo di fermentazione",
    boxes: "Boxe",
    piles: "Celle",
    bags: "Borse",
    selectZone: "Seleziona la zona",
    selectPlantation: "Seleziona la piantagione",
    deliveryMethod: "Metodo di consegna",
    totalPrice: "Prezzo totale",
  },
  memberDataSection: {
    import: "Importazioni",
    buyingStation: "Comprare la stazione",
    factory: "Fabbrica",
    factories: "Fabbriche",
    societies: "Società",
    factoriesName: "Nome della Fabbrica",
    factoriesProdChart: "Grafico di produzione delle fabbriche",
    factoryInfo: "Informazioni Fabbrica",
    factoryDashboard: "Dashboard della Fabbrica",
    factoryDashboardPage: {
      title: "Dashboard della Fabbrica",
      close: "Chiudi",
      resetFilters: "Reimposta Filtri",
      apply: "Applica",
      monthlySupplyTrend: "Andamento Mensile delle Forniture",
      processingEfficiency: "Efficienza di Lavorazione",
      funnelChart: "Grafico a Imbuto - Input -> Output",
      totalLoss: "Perdita Totale",
      noTarget: "Nessun obiettivo impostato",
      ytdScope: "(YTD {year})",
      operationalEfficiency: "Efficienza Operativa",
      target: "Obiettivo",
      actual: "Effettivo",
      farmerParticipation: "Partecipazione degli Agricoltori - Distribuzione del Contributo",
      totalInput: "Input Totale",
      totalOutput: "Output Totale",
      activeFarmers: "Agricoltori Attivi",
      rawIntake: "Ingresso Grezzo (Ciliegia Ricevuta)",
      processing: "Lavorazione (Ciliegia Lavorata)",
      output: "Output (Pergamino Prodotto)",
      currentPeriod: "Periodo Corrente",
      previousPeriod: "Periodo Precedente",
      volumePerTopFarmers: "Volume per Migliori Agricoltori",
      cumulativeImpact: "Impatto Cumulativo (%)",
      deliveries: "Consegne (kg)",
      operational: "Operativo",
      volume: "Volume (kg)",
      cumulative: "Cumulativo (%)",
      to: "a",
      ranges: {
        today: "Oggi",
        week: "Settimana",
        month: "Mese",
        year: "Anno",
        all: "Tutti",
      },
    },
    continue: "Continua",
    farmerId: "ID azienda agricola",
    farmerName: "Nome del coltivatore",
    farmerAddress: "Farmer Indirizzo",
    quality: "Qualità",
    quantity: "Quantità",
    importAll: "Importa tutto",
    importSelected: "Importo selezionato",
    fileLoaded: "File caricato con successo",
    incorrectHeaders: "Intestazioni scorrette",
    processingBatch: "Elaborazione Batch",
    purchaseOrder: "Ordine di acquisto",
    buyingStationDetails: "Dettagli della Stazione di Acquisto",
    buyingStationUsers: "Utenti della Stazione di Acquisto",
    activityLog: "Registro Attività",
    startDate: "Data di inizio",
    endDate: "Data di fine",
    selectCrop: "Seleziona Coltura",
    purchasingOrder: "Ordine di acquisto",
    totalCoffeeCherry: "Ciliegia totale del caffè",
    airHumidity: "Umidità dell'aria",
    density: "Densità",
    temperature: "Temperatura",
    beanMoistureContent: "Umidità del chicco",
    processType: "Tipo di processo",
    batchRating: "Seleziona la valutazione del batch",
    purchaseDate: "Data di acquisto",
    selectFarmer: "Seleziona Farmer",
    selectFarmers: "Seleziona Farmers",
    selectFarm: "Seleziona Agriturismo",
    selectPlantation: "Seleziona la piantagione",
    coffeeVariety: "Varietà di caffè",
    coffeeSpecies: "Specie di caffè",
    coffeeCherryQuantity: "Ciliegia di caffè quantità",
    coffeeCherryQuality: "Qualità del caffè",
    coffeeType: "Tipo di caffè",
    pricePerKg: "Prezzo per Kg",
    processingDone: "Fatto di elaborazione",
    processedCoffeeOut: "Caffè lavorato fuori",
    farmer: "Farmer",
    farm: "Fattoria",
    plantation: "Piantatura",
    farmers: "Agricoltori",
    farmLimitUsed: "Limite di fattoria utilizzato",
    phoneNumber: "Numero di telefono",
    farmSize: "Dimensione della fattoria",
    farmLocation: "Fattoria/Locazione",
    date: "Data",
    status: "Stato",
    noFarmers: "Nessun Agriturismo Trovato",
    approveReject: "Approvo/Rigetto",
    farms: "Aziende agricole",
    crops: "Colture",
    equipment: "Attrezzatura",
    noFarms: "Nessun agriturismo Trovato",
    views: "Vista",
    selectStatus: "Selezionare Stato",
    approved: "Approvazione",
    rejected: "Rifiuti",
    reject: "Rifiuti",
    approve: "Approvo",
    conclude: "Concludi",
    cancel: "Annulla",
    add: "Aggiungi",
    describeYourReason: "Descrivi il tuo motivo qui",
    userInformation: "Informazioni utente",
    userFarmRequest: "Richiesta dell'utente",
    userFarmInformation: "User Farm(s) Informazioni",
    activity: "Attività",
    activityType: "Tipo di attività",
    farmZone: "Zona agricola",
    farmerView: "Vista sul mare",
    cropType: "Tipo di coltura",
    cropVarity: "Varietà del raccolto",
    area: "Settore",
    cost: "Costo",
    geofence: "Geofence",
    map_views: "Visualizza mappa",
    viewAllFarms: "Visualizza tutti gli agriturismi",
    farmersDetails: "Dettagli dell'agriturismo",
    download: "Scarica",
    pOrder: {
      addNew: "Aggiungi nuovo",
      viewAll: "Vedi tutto",
      selectDate: "Seleziona la data",
      makeSelection: "Fai una selezione",
      coffeeType: "Tipo di caffè quantità",
      enterPrice: "Inserisci il prezzo",
      reqPurchaseDate: "La data di acquisto è richiesta",
      reqFarmer: "L'agricoltore è richiesto",
      reqCoffeeQnty: "La quantità di ciliegie di caffè è obbligatoria",
      reqPrice: "Prezzo per Kg è richiesto",
      grandTotal: "GRAND TOTALE",
      selectDateRange: "Seleziona l'intervallo di date",
      import: "Importazioni",
      purchaseId: "Acquisto Id",
      purchaseDate: "Data di acquisto",
      farmerName: "Nome del coltivatore",
      quality: "Qualità",
      quantity: "Quantità",
      pricePerKg: "Prezzo per Kg",
      selectBuyingStation: "Selezionare la stazione di acquisto",
      searchUser: "Utenti di ricerca",
      calendarView: "Calendario vista",
      purchaseListView: "Lista di acquisto",
      viewBy: "Vista da",
      typeDensity: "Tipo Densità",
      typeTemperature: "Tipo di temperatura",
      typeWaterContent: "Tipo contenuto di acqua",
    },
    farmActivity: "Attività agricola",
    showOnMap: "Mostra sulla mappa",
    farmInformation: "Informazioni sull'azienda",
    dateOfEntry: "Data di entrata",
    farmID: "ID azienda agricola",
    ownershipType: "Tipo di proprietà",
    locationAddress: "Indirizzo",
    goalType: "Tipo di gol",
    totalSize: "Dimensione totale",
    zones: "Zone",
    farmActivities: "Farm Activites",
    farmDetails: "Dettagli dell'agriturismo",
    totalFarmsRegistered: "Totale aziende",
    totalFarmArea: "Totale superficie agricola",
    totalZone: "Zona totale",
    zone: "Zona",
    totalCost: "Costo totale",
    selectFarmZone: "Seleziona Zona/Farm",
    productionType: "Tipo di produzione",
    certifications: "Certifications",
    geofences: "Geofences",
    farmsChart: "Grafico delle fattorie",
  },
 
    // Buying Station specific translations
    buyingStations: "Stazioni di acquisto",
    registerBuyingStation: "Registra stazione di acquisto",
    registerFactory: "Registra fabbrica",
    loadingFactory: "Caricamento fabbrica...",
    loadingBuyingStation: "Caricamento stazione di acquisto...",
    searchBuyingStation: "Cerca stazione di acquisto",
    searchFactory: "Cerca fabbrica",
    searchSociety: "Cerca Società",
    nameAndId: "Nome / ID",
    email: "Email",
    mobileNumber: "Numero di cellulare",
    role: "Ruolo",
    actions: "Azioni",
    view: "Visualizza",
    edit: "Modifica",
    activate: "Attiva",
    deactivate: "Disattiva",
    operator: "Operatore",
    supplier: "Fornitore",
    active: "Attivo",
    deactivated: "Disattivato",
    activatedSuccessfully: "Stazione di acquisto attivata con successo",
    deactivatedSuccessfully: "Stazione di acquisto disattivata con successo",
  
    factoryActivatedSuccessfully: "Fabbrica attivata con successo",
    factoryDeactivatedSuccessfully: "Fabbrica disattivata con successo",
    factoryRegisteredSuccessfully: "Fabbrica registrata con successo",
    
    // Buying Station Details specific translations
    userDetails: "Dettagli utente",
    name: "Nome",
    provinceState: "Provincia/Stato",
    villageCityTown: "Villaggio/Città/Cittadina",
    country: "Paese",
    associatedFarms: "Fattorie associate",
    back: "Indietro",
    addPurchaseOrder: "Aggiungi ordine di acquisto",
    cherryCollection: "Raccolta ciliegie",
    addCherryCollection: "Aggiungi Raccolta Ciliegie",
    search: "Cerca",
    orderId: "ID ordine",
    farmFarmer: "Fattoria / Agricoltore",
    coffeeSpeciesVariety: "Specie / Varietà di caffè",
    quantityPrice: "Quantità / Prezzo",
    delete: "Elimina",
    
    // Processing Batch specific translations
    addProcessingBatch: "Aggiungi lotto di lavorazione",
    batchId: "ID lotto",
    lots: "Lotti",
    greenCoffeeOut: "Caffè verde fuori",
    startEndDate: "Data inizio/Data fine",
    
    // Associated Farms specific translations
    addFarm: "Aggiungi fattoria",
    farmNameAndId: "Nome e ID fattoria",
    addressOfProduction: "Indirizzo di produzione",
    areaHa: "Area (ha)",
    type: "Tipo",
    eudrDeforestationStatus: "Stato disboscamento EUDR",
    eudrDeforestationStatusTT: "Stato valutazione rischio disboscamento EUDR",
    zeroNegligibleProbability: "Probabilità zero/trascurabile",
    assessments: "Valutazioni",
    riskAssessment: "Valutazione del rischio",
    compliant: "Conforme",
    nonCompliant: "Non conforme",
    pending: "In attesa",
    dateOfSubmission: "Data di invio",
    dateOfExpiry: "Data di scadenza",
    selectFarms: "Seleziona Aziende",
    reviewSelection: "Rivedi Selezione",
    next: "Avanti",
    reviewMappingPrompt: "Hai selezionato {count} azienda/e. Conferma per associarle a questa stazione di acquisto.",
    confirmMapping: "Conferma Associazione",
    farmsMappedSuccess: "Aziende associate con successo",
    farmsMappedError: "Impossibile associare le aziende",
    owner: "Proprietario",

    buyingStationOrder: {
      bulkImport: {
        importBulkData: "Importa Dati in Blocco",
        importButton: "Importa Ordini di Acquisto in Blocco",
        title: "Importazione in Blocco dei Dati degli Ordini di Acquisto",
        // Upload tab
        templateNote: "Scarica e usa i modelli qui sotto per importare gli ordini di acquisto in blocco.",
        selectTemplate: "Seleziona Modello",
        templateXls: "Importa Formato XLS",
        downloadXls: "Scarica Formato XLS",
        selectFile: "Seleziona il file per Caricare i Dati",
        dropHere: "oppure trascina e rilascia qui",
        fileUploaded: "Il file è stato caricato con successo.",
        importantNote: "Nota Importante",
        importantNoteDetail:
          "Utilizzare i modelli forniti sopra per i caricamenti in blocco. Altri formati causeranno un errore.",
        unsupportedFileFormat: "Questo formato di file non è supportato.",
        invalidFileFormat: "Caricare un file .xlsx, .xls o .csv valido utilizzando il modello fornito.",
        templateErrorIntro:
          "Il file caricato non corrisponde al modello richiesto. Scaricare il modello e riprovare.",
        importingTitle: "Importazione in corso...",
        importingNote:
          "I file caricati sono attualmente in elaborazione.\nTi avviseremo una volta che i file saranno stati caricati con successo.",
        // Result page
        importCompleted: "Importazione Completata",
        recordsReadyToImport: "record pronti per l'importazione",
        tabTotalRecords: "Record Totali",
        tabSuccess: "Successo",
        tabIssues: "Problemi",
        filterAll: "Tutti",
        filterSuccess: "Successo",
        issuesDetected: "Problemi Rilevati",
        issuesDetectedHeading: "Discrepanza rilevata:",
        issuesDetectedDescription:
          "Alcune righe presentano problemi di dati (ad es., data di acquisto non valida, agricoltore, fattoria o dati del caffè sconosciuti). Esaminarle e risolverle prima dell'invio finale.",
        deleteRowsWithIssues: "Elimina le righe con Discrepanze dei Dati",
        // Table headers
        purchaseDate: "Data di acquisto",
        farmer: "Agricoltore",
        farm: "Fattoria",
        buyingStation: "Stazione di acquisto",
        coffeeQuantityQuality: "Quantità e qualità del caffè",
        plantation: "Piantagione",
        coffeeSpecies: "Specie di caffè",
        coffeeVariety: "Varietà di caffè",
        coffeeType: "Tipo di caffè",
        coffeeCherryQuantity: "Quantità di ciliegie di caffè",
        coffeeCherryQuality: "Qualità delle ciliegie di caffè",
        pricePerKg: "Prezzo per Kg",
        receiptNo: "Numero Ricevuta",
        lotId: "ID Lotto",
        photos: "Foto",
        // Actions / dialogs
        purchaseOrder: "Ordine di acquisto",
        detailsTitle: "Dettaglio dell'ordine di acquisto",
        editRecord: "Modifica record",
        deleteRecord: "Elimina record",
        deleteRecordConfirm:
          "Sei sicuro di voler eliminare questo record? Questa azione non può essere annullata.",
        deleteDiscrepancyConfirm:
          "Sei sicuro di voler eliminare tutte le {count} riga/righe con problemi? Questa azione non può essere annullata.",
        cancelImportTitle: "Annulla Importazione",
        cancelImportConfirm:
          "Sei sicuro di voler annullare questa importazione? I record validati non saranno più importabili.",
        cancelImportConfirmBtn: "Annulla Importazione",
        importConfirm: "Importare ora {count} record validi?",
        recordUpdatedSuccess: "Record aggiornato con successo.",
        recordsDeletedSuccess: "Record eliminati con successo.",
        importCancelledSuccess: "Importazione annullata con successo.",
        genericError: "Qualcosa è andato storto. Riprova.",
        noDataFound: "Nessun dato trovato.",
        // Edit dialog
        selectFactory: "Seleziona fabbrica",
        selectFarmer: "Seleziona agricoltore",
        selectFarm: "Seleziona fattoria",
        selectPlantation: "Seleziona piantagione",
        submit: "Invia",
        addImage: "Aggiungi immagine",
        addedBy: "Aggiunto da",
        close: "Chiudi",
        // Success dialog
        successDialogTitle: "Messaggio di Successo",
        importedSuccessfully: "{count} ordine/i di acquisto sono stati importati con successo.",
        // History
        historyFile: "Nome del File",
        historyImportedOn: "Importato Il",
        historyEmpty: "Nessuna cronologia di importazione in blocco ancora.",
        statusValidating: "In Convalida",
        statusSuccess: "Importato",
        statusCancelled: "Annullato",
        // Error-code labels (tooltips / field messages)
        errorInvalidPurchaseDate: "La data di acquisto non è valida.",
        errorMissingPurchaseDate: "La data di acquisto è mancante.",
        errorMissingMemberId: "L'ID membro è mancante.",
        errorInvalidMemberIdFormat: "Il formato dell'ID membro non è valido. Previsto: Nome agricoltore - Nome stazione di acquisto - ID fattoria.",
        errorInvalidFarmerName: "L'agricoltore non è stato trovato nella tua organizzazione.",
        errorInvalidBuyingStationName: "La stazione di acquisto non è stata trovata nella tua organizzazione.",
        errorInvalidFarm: "La fattoria non è stata trovata nella tua organizzazione.",
        errorMissingQuantity: "La quantità di ciliegie di caffè è mancante.",
        errorInvalidQuantity: "La quantità di ciliegie di caffè deve essere un numero maggiore di zero.",
        errorMissingQuality: "La qualità delle ciliegie di caffè è mancante.",
        errorInvalidQuality: "La qualità delle ciliegie di caffè non è stata riconosciuta.",
        errorMissingPrice: "Il prezzo è mancante.",
        errorInvalidPrice: "Il prezzo deve essere un numero valido.",
        // Filter chip short labels
        chipInvalidPurchaseDate: "Data di Acquisto Non Valida",
        chipMissingPurchaseDate: "Data di Acquisto Mancante",
        chipMissingMemberId: "ID Membro Mancante",
        chipInvalidMemberIdFormat: "Formato ID Membro Non Valido",
        chipInvalidFarmerName: "Agricoltore Non Valido",
        chipInvalidBuyingStationName: "Stazione di Acquisto Non Valida",
        chipInvalidFarm: "Fattoria Non Valida",
        chipMissingQuantity: "Quantità Mancante",
        chipInvalidQuantity: "Quantità Non Valida",
        chipMissingQuality: "Qualità Mancante",
        chipInvalidQuality: "Qualità Non Valida",
        chipMissingPrice: "Prezzo Mancante",
        chipInvalidPrice: "Prezzo Non Valido",

      },
    },
    processingBatchBulkImport: {
      bulkImport: "Importa Lotti di Lavorazione in Blocco",
      title: "Importazione in Blocco dei Lotti di Lavorazione",
      instructions: "Carica un file CSV o XLSX usando il modello qui sotto. Ogni riga crea un lotto di lavorazione.",
      downloadCsv: "Scarica modello CSV",
      downloadXlsx: "Scarica modello XLSX",
      selectFile: "Seleziona file CSV o XLSX",
      rowsParsed: "{count} riga/e pronta/e per l'importazione.",
      import: "Importa",
      imported: "Importati {created} di {total} lotto/i.",
      failed: "{failed} riga/e non riuscita/e.",
      rowError: "Riga {row}",
      emptyFile: "Il file non ha righe di dati.",
      missingColumns: "Colonne richieste mancanti: {columns}",
      noBuyingStation: "Nessuna stazione di acquisto selezionata.",
      validating: "Validazione righe…",
      total: "Totale",
      valid: "Valido",
      invalid: "Non Valido",
      all: "Tutti",
      statusValid: "Valido",
      statusInvalid: "Non Valido",
      issues: "Problemi",
      back: "Indietro",
      importValid: "Importa {count} riga/e valida/e",
      done: "Fatto",
      rowCol: "Riga",
      startDateCol: "Data di Lavorazione",
      purchaseOrdersCol: "Codici Acquisto",
      processTypeCol: "Tipo di Lavorazione",
      gradeCol: "Grado",
      seasonCol: "Stagione",
      statusCol: "Stato",
      purchaseDateCol: "Data di Acquisto",
      processDateCol: "Data di Lavorazione",
      parchmentCol: "Pergamino (Kg)",
      bagsCol: "Sacchi",
      vehiclePlateCol: "Targa del Veicolo",
      harvestedCol: "Raccolto",
      pulpedCol: "Pulpato",
      washedCol: "Lavato",
      dryingStartedCol: "Essiccazione Iniziata",
      movedToStoreCol: "Spostato in Magazzino",
      templateNote: "Scarica e utilizza i modelli qui sotto per importare lotti di lavorazione in blocco.",
      selectTemplate: "Seleziona Modello",
      templateCsv: "Formato Importazione CSV",
      templateXls: "Formato Importazione XLS",
      downloadCsvFormat: "Scarica Formato CSV",
      downloadXls: "Scarica Formato XLS",
      importingTitle: "Importazione in Blocco dei Lotti di Lavorazione",
      importingNote: "Il file caricato è in fase di elaborazione.\nNon fare clic su annulla, chiudi o aggiorna questa pagina per evitare interruzioni.",
      importantNote: "Nota Importante",
      importantNoteDetail: "Utilizzare i modelli forniti sopra per l'importazione in blocco dei lotti di lavorazione. Altri formati causeranno errori.",
      invalidFileFormat: "Si prega di caricare un file .csv, .xlsx o .xls valido usando il modello fornito.",
      unsupportedFileFormat: "Questo formato di file non è supportato.",
      templateErrorIntro: "Il file caricato non corrisponde al modello richiesto. Scarica il modello e riprova.",
      importCompleted: "Importazione Completata",
      tabTotalRecords: "Totale Registrazioni",
      tabSuccess: "Successo",
      tabIssues: "Problemi",
      filterAll: "Tutti",
      filterSuccess: "Successo",
      issuesDetected: "Problemi Rilevati",
      issuesDetectedHeading: "Problemi Rilevati:",
      issuesDetectedDescription: "Alcune righe presentano problemi di dati (es.: date mancanti, tipo di lavorazione sconosciuto, valore pergamino non valido). Si prega di revisionarle e risolverle prima dell'invio finale.",
      deleteRowsWithIssues: "Elimina righe con problemi",
      editRecord: "Modifica registrazione",
      deleteRecord: "Elimina registrazione",
      deleteRecordConfirm: "Sei sicuro di voler eliminare questa registrazione? Questa azione non può essere annullata.",
      deleteDiscrepancyConfirm: "Sei sicuro di voler eliminare tutte le {count} righe con problemi? Questa azione non può essere annullata.",
      cancelImportTitle: "Annulla Importazione",
      cancelImportConfirm: "Sei sicuro di voler annullare questa importazione? Le registrazioni validate non saranno più importabili.",
      cancelImportConfirmBtn: "Annulla Importazione",
      importConfirm: "Importare {count} registrazione/i valida/e ora?",
      recordUpdatedSuccess: "Registrazione aggiornata con successo.",
      recordsDeletedSuccess: "Registrazioni eliminate con successo.",
      importCancelledSuccess: "Importazione annullata con successo.",
      genericError: "Si è verificato un errore. Riprova.",
      noDataFound: "Nessun dato trovato.",
      editRecordTitle: "Modifica Registrazione",
      submit: "Invia",
      detailsTitle: "Dettagli Lotto di Lavorazione",
      close: "Chiudi",
      successDialogTitle: "Messaggio di Successo",
      importedSuccessfully: "{count} registrazione/i di lotti di lavorazione importata/e con successo.",
      historyFile: "Nome File",
      historyImportedOn: "Importato il",
      historyEmpty: "Nessuna cronologia di importazione in blocco.",
      statusValidating: "Validazione",
      statusSuccess: "Importato",
      statusCancelled: "Annullato",
      errorCodePurchaseDateRequired: "La data di acquisto è obbligatoria.",
      errorCodeInvalidPurchaseDate: "Il formato della data di acquisto non è riconosciuto.",
      errorCodeProcessDateRequired: "La data di lavorazione è obbligatoria.",
      errorCodeInvalidProcessDate: "Il formato della data di lavorazione non è riconosciuto.",
      errorCodeUnknownProcessType: "Il tipo di lavorazione non è riconosciuto.",
      errorCodeNoOrdersForDate: "Nessun ordine di acquisto trovato per la data di acquisto indicata.",
      errorCodeParchmentInvalid: "Il valore del pergamino (Kg) non è valido.",
      errorCodeParchmentExceedsCherry: "Il pergamino (Kg) non può superare la quantità totale di ciliegie di caffè.",
      errorCodeInvalidData: "Uno o più campi contengono dati non validi.",
      chipPurchaseDateRequired: "Data Acquisto Richiesta",
      chipInvalidPurchaseDate: "Data Acquisto Non Valida",
      chipProcessDateRequired: "Data Lavorazione Richiesta",
      chipInvalidProcessDate: "Data Lavorazione Non Valida",
      chipUnknownProcessType: "Tipo Lavorazione Sconosciuto",
      chipNoOrdersForDate: "Nessun Ordine per questa Data",
      chipParchmentInvalid: "Pergamino Non Valido",
      chipParchmentExceedsCherry: "Pergamino Supera le Ciliegie",
      chipInvalidData: "Dati Non Validi",
    },
    greenCoffee: {
      bulkImport: {
        importButton: "Importa Caffè Verde in Blocco",
        title: "Importazione Dati Caffè Verde in Blocco",
        breadcrumb: "Panoramica Caffè > Molitura a Secco",
        tabImport: "Importa",
        tabHistory: "Cronologia",
        templateNote:
          "Scarica e usa i modelli qui sotto per importare il caffè verde in blocco.",
        selectTemplate: "Seleziona Modello",
        templateXls: "Importa Formato XLS",
        importingTitle: "Importazione Dati Caffè Verde in Blocco",
        importingNote:
          "Il file caricato è attualmente in elaborazione.\nNon fare clic su annulla, chiudere o aggiornare questa pagina per evitare interruzioni.",
        importCompleted: "Importazione Completata",
        tabTotalRecords: "Record Totali",
        tabSuccess: "Successo",
        tabFailed: "Falliti",
        tabIssues: "Problemi",
        tabDataDiscrepancies: "Discrepanze dei Dati",
        filterAll: "Tutti",
        filterSuccess: "Successo",
        filterIssues: "Problemi",
        issuesDetectedHeading: "Problemi Rilevati:",
        issuesDetectedDescription:
          "Alcuni lotti presentano problemi di dati (ad es., numero di produzione non valido, numero di produzione non presente nel sistema). Esaminarli e risolverli prima dell'invio finale.",
        deleteLotsWithDataDiscrepancies: "Elimina Lotti con Discrepanze dei Dati",
        lotId: "ID Lotto",
        lotIdAndOutturn: "ID Lotto e Produzione",
        grower: "Coltivatore",
        coffeeType: "Tipo di Caffè",
        grossAndNetWeight: "Peso Lordo e Peso Netto",
        issuesDetected: "Problemi Rilevati",
        issueOutturnNumberMismatchTitle: "Numero di produzione non corrispondente:",
        issueOutturnNumberMismatchDescription:
          "Questa produzione non corrisponde ad alcun record di Consegna Pergamino esistente. Assicurarsi che il Numero di Produzione sia stato collegato manualmente a livello di Fabbrica prima di ricaricare.",
        issueDuplicateOutturnNumberTitle: "Numero di Produzione Duplicato:",
        issueDuplicateOutturnNumberDescription:
          "Il numero di produzione compare più volte in questo documento caricato.",
        issueMissingOutturnNumberTitle: "Numero di Produzione Mancante:",
        issueMissingOutturnNumberDescription:
          "La riga caricata non contiene un Numero di Produzione. È richiesto un identificativo di Produzione univoco e valido per abbinare il record al sistema della fabbrica.",
        issueGrowerIdentityMismatchTitle: "Discrepanza dell'Identità del Coltivatore:",
        issueGrowerIdentityMismatchDescription:
          "Il numero di produzione è registrato nel nostro sistema sotto il Coltivatore {mobileGrowerName}, ma il file caricato lo assegna a {xlsGrowerName}. Sovrascrittura dei dati limitata.",
        issueMissingGrowerCredentialsTitle: "Credenziali del Coltivatore Mancanti:",
        issueMissingGrowerCredentialsDescription:
          "Nel record mancano il Nome del Coltivatore o l'ID del Coltivatore. Questi campi di dati sono obbligatori per verificare la proprietà della fabbrica prima che il lotto possa essere riconciliato.",
        editRecord: "Modifica record",
        deleteRecord: "Elimina record",
        downloadXls: "Scarica Formato XLS",
        selectFile: "Seleziona il file per Caricare i Dati",
        dropHere: "oppure trascina e rilascia qui",
        importantNote: "Nota Importante",
        importantNoteDetail:
          "Utilizzare i modelli forniti sopra per importare il caffè verde in blocco. Altri formati causeranno un errore.",
        invalidFileFormat: "Caricare un file .xlsx o .xls valido utilizzando il modello fornito.",
        unsupportedFileFormat: "Questo formato di file non è supportato.",
        importFailed: "Importazione Fallita",
        importFailedIntro:
          "Impossibile importare il file. Controllare il formato del modello e i dati delle righe, quindi riprovare.",
        templateErrorIntro:
          "Il file caricato non corrisponde al modello richiesto. Scaricare il modello XLS e riprovare.",
        tryAgain: "Riprova",
        errorDetails: "Dettagli",
        historyEmpty: "Nessuna cronologia di importazione in blocco ancora.",
        // Validation review / import flow
        validationSummaryTitle: "Riepilogo Validazione",
        recordsReadyToImport: "record pronti per l'importazione",
        editRecordTitle: "Modifica Record",
        growerCode: "Codice Coltivatore",
        growerName: "Nome Coltivatore",
        greenBeansTotal: "Peso in Ingresso Con Sacchi (Kg)",
        selectedCount: "selezionato/i",
        deleteSelected: "Elimina Selezionati",
        deleteRecordConfirm:
          "Sei sicuro di voler eliminare questo record? Questa azione non può essere annullata.",
        deleteSelectedConfirm:
          "Sei sicuro di voler eliminare i {count} record selezionati? Questa azione non può essere annullata.",
        deleteDiscrepancyConfirm:
          "Sei sicuro di voler eliminare tutti i {count} lotti con discrepanze dei dati? Questa azione non può essere annullata.",
        cancelImportTitle: "Annulla Importazione",
        cancelImportConfirm:
          "Sei sicuro di voler annullare questa importazione? I record validati non saranno più importabili.",
        cancelImportConfirmBtn: "Annulla Importazione",
        importConfirm: "Importare ora {count} record validi?",
        recordUpdatedSuccess: "Record aggiornato con successo.",
        recordsDeletedSuccess: "Record eliminati con successo.",
        importCancelledSuccess: "Importazione annullata con successo.",
        importSuccess: "Importazione completata con successo.",
        genericError: "Qualcosa è andato storto. Riprova.",
        // Issue / error-code labels
        issueInvalidDataTitle: "Dati Non Validi:",
        issueInvalidDataDescription:
          "Uno o più campi contengono dati non validi. Esaminarli e correggerli.",
        errorCodeOutturnMismatch:
          "Questo numero di produzione non corrisponde ad alcun record di consegna pergamino esistente.",
        errorCodeOutturnMissing: "Il numero di produzione è mancante.",
        errorCodeOutturnDuplicate:
          "Questo numero di produzione è duplicato nel file o esiste già nel sistema.",
        errorCodeGrowerMismatch:
          "Il nome/codice del coltivatore non corrisponde alla consegna pergamino registrata.",
        errorCodeGrowerMissing: "Il nome o il codice del coltivatore è mancante.",
        errorCodeInvalidData: "Uno o più campi contengono dati non validi.",
        // History table
        historyFile: "Nome del File",
        historyImportedOn: "Importato Il",
        historyUploadedBy: "Caricato Da",
        historyCreatedDate: "Data di Creazione",
        historyTotalRecords: "Record Totali",
        historyErrorRecords: "Record con Errori",
        // Bulk import status labels
        statusValidating: "In Convalida",
        statusSuccess: "Importato",
        statusCancelled: "Annullato",
        // Edit record dialog
        editFieldId: "ID",
        inputWeightWithBags: "Peso in Ingresso Con Sacchi",
        qualityControl: "Controllo Qualità",
        submit: "Invia",
        noMillingOutputs: "Nessun dettaglio di output di molitura.",
        millingCleanCoffee: "Caffè Pulito (Dettagli Output Molitura)",
        millingBags: "Sacchi (Dettagli Output Molitura)",
        millingPockets: "Tasche (Dettagli Output Molitura)",
        millingWeight: "Peso (Dettagli Output Molitura)",
        millingBulkOutturn: "Produzione Sfusa (Dettagli Output Molitura)",
        millingRatio: "Rapporto (Dettagli Output Molitura)",
        // Detail dialog
        detailsTitle: "Dettagli Caffè Verde",
        outturnNo: "N. Produzione",
        close: "Chiudi",
        // Success dialog
        successDialogTitle: "Messaggio di Successo",
        importedSuccessfully:
          "{count} record di caffè verde sono stati importati con successo.",
        // Filter chip short labels (per error category)
        chipOutturnMismatch: "Numero di Produzione Non Corrispondente",
        chipOutturnMissing: "Numero di Produzione Mancante",
        chipOutturnDuplicate: "Numero di Produzione Duplicato",
        chipGrowerMismatch: "Discrepanza dell'Identità del Coltivatore",
        chipGrowerMissing: "Credenziali del Coltivatore Mancanti",
        chipInvalidData: "Dati Non Validi",
      },
      processGreenCoffee: "Processare Caffè Verde",
      addedBy: "Aggiunto da",
      selectProductType: "Seleziona Tipo di Prodotto",
      processDate: "Data di Processo",
      selectProcessingBatch: "Seleziona Lotto di Lavorazione",
      lotIdAndDate: "ID Lotto e Data",
      typeAndQuantity: "Tipo e Quantità",
      supplier: "Fornitore",
      outturnNumber: "Numero produzione",
      totalInputQuantity: "Quantità Totale in Ingresso (kg)",
      qualityControl: "Controllo qualità",
      airHumidity: "Umidità dell'aria (valore in %)",
      density: "Densità (kg/cm3)",
      greenCoffeeQualityScore: "Punteggio Qualità Caffè Verde",
      batchProduction: "Produzione Lotto",
      unsortedGreenBeans: "Chicchi Verdi Non Selezionati (kg)",
      batchProductionDensity: "Densità Produzione Lotto (kg/cm3)",
      percentagePrimaryDefect: "Percentuale difetto primario",
      percentageSecondaryDefect: "Percentuale difetto secondario",
      greenBeans: "Chicchi Verdi",
      totalGreenBeans: "Totale chicchi verdi (kg)",
      unitSize: "Dimensione Unità (kg)",
      totalBags: "Totale sacchi",
      leftoverQuantity: "Quantità residua",
      leftoverQuantityDesc: "La Quantità Residua è la quantità rimanente che non può formare un sacco completo. Rappresenta la quantità rimasta dopo aver riempito il numero massimo di unità complete dalla fornitura totale.",
      expiryDate: "Data di scadenza",
      label: "Etichetta",
      qualityControlButton: "Controllo qualità",
      valueInPercent: "valore in %",
      kgCm3: "kg/cm3",
      complete: "Completo",
      lotIdOutturnNo: "ID Lotto / N. Produzione",
      startDate: "Data di inizio",
      greenBeansQualityGrading: "Classificazione Qualità Chicchi Verdi",
      totalQuantity: "Quantità totale",
      quantity: "Quantità",
      packing: "Imballaggio",
      bag: "Sacco",
      qualityScore: "Punteggio qualità",
      noLotsYet: "Nessun lotto ancora. Aggiungi qualità dal flusso di creazione.",
      lotId: "ID Lotto",
      percentage: "Percentuale",
      createQualityGrade: "Crea Qualità",
      finishGrading: "Termina Classificazione",
      finishGradingDesc: "Una volta terminato non potrai più classificare questo lotto. Lo scarto sarà calcolato automaticamente al completamento.",
      finishGradingButton: "Termina Classificazione",
      addNewQualityGrade: "Aggiungi Nuova Qualità",
      totalGreenBeansExceeded: "La quantità totale classificata non può superare il totale dei chicchi verdi.",
      lotIdAlreadyExists: "Questo ID lotto è già in uso. Usa un ID lotto diverso.",
      toAddRecord: "per aggiungere un record.",
      registeredSuccess: "Caffè verde registrato con successo",
      exportNotImplemented: "Esportazione non implementata",
      processingBatchRequired: "Il lotto di lavorazione è obbligatorio",
      outturnAvailable: "Il numero di produzione è disponibile",
      outturnExists: "Questo numero di produzione esiste già. Inserire un valore univoco.",
      totalGreenBeansRequired: "Il totale dei chicchi verdi è obbligatorio",
      enterHere: "Inserire qui",
      viewTitle: "Classificazione qualità chicchi verdi",
      parchmentInformation: "Informazioni pergamino",
      processInformation: "Informazioni processo",
      greenBeansInformation: "Informazioni chicchi verdi",
      traceabilityLabel: "Etichetta di tracciabilità",
      waste: "Scarto",
      downloadLabel: "Scarica etichetta",
      startCupping: "Avvia degustazione",
      cuppingHistory: "Cronologia degustazione",
      noDataFound: "Nessun dato trovato.",
      noParchmentBatches: "Nessun lotto pergamino collegato.",
      noQualityGrades: "Nessuna qualità registrata.",
      batchId: "ID lotto",
      species: "Specie",
      variety: "Varietà",
      process: "Processo",
      batchRating: "Valutazione lotto",
      humidity: "Umidità",
      totalCoffeeCherryQty: "Quantità totale ciliegia",
      weightBeforeProcessing: "Peso prima della lavorazione",
      numberOfBags: "Numero di sacchi",
      externalId: "ID esterno",
      qrCode: "Codice QR",
      latestCuppingScore: "Punteggio degustazione più recente",
      totalWaste: "Scarto totale",
      close: "Chiudi",
      unitSizeKgBag: "Dimensione unità (kg/sacco)",
      grade: "Grado",
      selectGrade: "Seleziona grado",
      quantityRequired: "La quantità è obbligatoria",
      quantityMustBePositive: "La quantità deve essere maggiore di 0",
      unitSizeRequired: "La dimensione unità è obbligatoria",
      unitSizeMustBePositive: "La dimensione unità deve essere maggiore di 0",
      gradeRequired: "Il grado è obbligatorio",
      labelRequired: "L'etichetta è obbligatoria",
      cupping: "Degustazione",
      cuppingInformation: "Informazioni degustazione",
      cupperName: "Nome assaggiatore",
      cuppingDate: "Data degustazione",
      enterCupperName: "Inserire nome assaggiatore",
      attachFiles: "Allega file",
      selectFilesToUpload: "Seleziona file da caricare",
      orDragAndDrop: "oppure trascina e rilascia qui",
      lightRoast: "Tostatura Leggera",
      roastingTime: "Tempo di Tostatura",
      roastingTemperature: "Temperatura di Tostatura",
      qualities: "Qualità",
      uniformity: "Uniformità",
      cleanCup: "Tazza Pulita",
      sweetness: "Dolcezza",
      overall: "Complessivo",
      defects: "Difetti",
      finalScore: "Punteggio Finale",
      sessionDetails: "Dettagli sessione",
      noCuppingHistory: "Nessuna cronologia degustazione per questo caffè verde.",
      cuppingDataSaved: "Dati degustazione salvati.",
      date: "Data",
      roast: "Tostatura",
      score: "Punteggio",
    },
    confirmDialog: {
      delete: {
        title: "Elimina stazione di acquisto",
        message: "Sei sicuro di voler eliminare questa stazione di acquisto?",
        confirmBtn: "Elimina",
      },
      activate: {
        title: "Attiva",
        message: "Sei sicuro di voler attivare questo {entity}?",
        confirmBtn: "Attiva",
      },
      deactivate: {
        title: "Disattiva",
        message: "Sei sicuro di voler disattivare questo {entity}?",
        confirmBtn: "Disattiva",
      },
    },
    
    registerNewFactory: "Registra nuova fabbrica",
    selectHowYouWantToProceed: "Seleziona come desideri procedere",
    single: "Singolo",
    multiple: "Multiplo",
    user: "Utente",
    createNewFactory: "Crea nuova fabbrica",
    factoryName: "Nome fabbrica",
    factoryNumber: "Numero fabbrica",
    firstName: "Nome",
    lastName: "Cognome",
    primaryEmailAddress: "Indirizzo email principale",
    submit: "Invia",
    downloadTemplate: "Scarica modello",
    templateInfo: "Scarica il file modello per vedere il formato richiesto per la registrazione in massa.",
    templateFormat: "Per favore, fornisci il file in formato CSV.",
    selectFileToUpload: "Seleziona il file per caricare i dati",
    uploadFileOrDragAndDrop: "o trascina e rilascia qui",
};
